<template>
  <g class="vg-chart vg-bar-chart" :transform="transform">
    <clipPath :id="'clip-path-' + _uid">
      <slot name="clip" v-bind="{xScale, yScale}">
        <rect v-bind="defaultClipPath"></rect>
      </slot>
    </clipPath>

    <x-axis
      :interval="xInterval"
      :y-translate="yRange[0] + 2"
      :x-scale="xScale"
      :tick-size="0"
      :tick-padding="5"
      anchor="top"
      :formatted="xFormat">
    </x-axis>
    <bar-plot
      :data-view="dataView"
      :x-scale="xScale"
      :y-scale="yScale"
      :clip-path="`url(#clip-path-${_uid})`"
      v-bind="$attrs"
      v-on="$listeners">
    </bar-plot>
  </g>
</template>

<script>
import BarPlot from 'vue-graphics/components/BarPlot.vue'
import XAxis from 'vue-graphics/components/XAxis'
import {dataViewMixin, userSpaceMixin} from 'vue-graphics/mixins'
import {DomainHelper, IntervalHelper, TransformHelper} from 'vue-graphics/helpers'
import {scaleBand, scaleLinear} from 'd3-scale'

export default {
  name: 'BarChart',
  components: {BarPlot, XAxis},
  mixins: [dataViewMixin, userSpaceMixin],
  inheritAttrs: false,
  props: {
    x: {
      type: [Function, String, Number],
      required: true
    },
    y: {
      type: [Function, String, Number],
      required: true
    },
    xDomain: {
      type: [Function, Array],
      default: DomainHelper.UNIQUE('x')
    },
    yDomain: {
      type: [Function, Array],
      default: DomainHelper.CLAMPED_MINMAX('y', 0)
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Number,
      default: 0.1
    },
    xFormat: Function,
    yFormat: Function
  },
  computed: {
    layout () {
      const t = new TransformHelper()
      return this.horizontal ? t.invert() : t.flipY()
    },
    xScale () {
      return scaleBand()
        .domain(this.domain.x)
        .range(this.xRange)
        .paddingInner(this.padding)
        .paddingOuter(0)
    },
    yScale () {
      return scaleLinear()
        .domain(this.domain.y)
        .rangeRound(this.yRange)
    },
    defaultClipPath () {
      const {xRange, yRange} = this
      return {
        x: Math.min(xRange[0], xRange[1]),
        y: Math.min(yRange[0], yRange[1]),
        width: Math.abs(xRange[0] - xRange[1]) + 5,
        height: Math.abs(yRange[0] - yRange[1]),
        stroke: 'none',
        fill: '#000'
      }
    }
  },
  methods: {
    xInterval: IntervalHelper.BETWEEN(true)
  }
}
</script>

<style lang="scss">
.vg-bar-chart {
  .vg-text-label {
    font-family: $font-CuratorRegular;
    font-size: 14px;
  }

  .vg-baseline {
    stroke: $black;
    opacity: 0.5;
    stroke-width: 1;
  }
}
</style>
